module.exports = __webpack_public_path__ + "static/media/alterar-unidade.85484e89.svg";